<template>
  <div style="height:100%">
    <SplitContainer21 style="height:100%" :layout="12">
      <template #top>
        <TableMain name="one table" ref="InventTable1" :fields="fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="true" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :isBusy="isBusy_table1" :hb_table_class="'hb_table_inventsei_class1'"
          :table_height_adjust="-8" :loading_width="60" @on_query="on_query" @state_change="state_change"
          :show_toolbar_button="[0, 0, 0, 0, 0]" @tool_invoke="tool_invoke" @current_changed="current_changed" tableref="97c63538a8fb45cdb5ffb9b81218b32f">
          <template #query>
            {{ $t("common.invent") + $t("common.num") }}：<el-input clearable size="small" style="width: 150px"
              v-model="ItemId"></el-input>
            {{ $t("common.invent") + $t("common.name") }}：<el-input clearable size="small" style="width: 200px"
              v-model="NameAlias"></el-input>
            {{ $t("common.customer") + $t("common.account") }}：<el-input clearable size="small" style="width: 150px"
              v-model="TEC_CustAccount">
            </el-input>
            {{ $t("common.customer") + $t("common.name") }}：<el-input clearable size="small" style="width: 200px"
              v-model="SEI_Name"></el-input>
          </template>
          <template #toolbar>
            <el-tooltip content="数据同步" placement="top" effect="light">
              <el-button type="info" plain style="width: 55px" class="ml-2" @click="InvokeData"><i
                  class="iconfont icon-refresh"></i></el-button>
            </el-tooltip>
          </template>
        </TableMain>
      </template>
      <template #bottom>
        <TableMain name="one table" ref="InventTable2" :fields="fields2" :title="table_title.title2"
          :show_query_container="false" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
          :loading_width="50" :query_button_label="query_lable" :isBusy="isBusy_table2"
          :hb_table_class="'hb_table_inventsei_class2'" tableref="a6180ff51a4945fda5aca25fa6076e53">
        </TableMain>
      </template>
    </SplitContainer21>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import * as InventTableController from "../../controllers/base/InventTableController"
import TestQueryPanel from "../components/base/TestQueryPanel"
import BaseContainer from "../components/BaseContainer"
import SplitContainer21 from "../components/container/SplitContainer21"
import BaseModal from "../components/modals/baseModal"
import TableMain from "../components/table/TableMain"

export default {
  name: "InventTableSEI",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
    SplitContainer21,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_sei_invent",
        title2: "table_invent",
      },
      fields: InventTableController.fields.default,
      fields2: InventTableController.fields.detail_fields,
      isBusy_table1: false,
      isBusy_table2: false,
      ItemId: "",
      NameAlias: "",
      TEC_CustAccount: "",
      SEI_Name: "",
    }
  },
  created() { },
  methods: {
    //#region 查询
    async on_query(set_data, date_range) {
      ///模拟数据
      this.isBusy_table1 = true
      if (!set_data || _.isNull(set_data)) {
        this.isBusy_table1 = false
        return
      } else {
        this._date_range = date_range
        this._set_data = set_data
      }
      if (_.isNull(date_range)) {
        this.msgModal(this.$t("notify.wait_too_long")).then(
          async (value) => {
            if (value) {
              await this.excuteQuery(set_data, date_range)
            } else {
              set_data([])
              this.isBusy_table1 = false
            }
          }
        )
      } else {
        await this.excuteQuery(set_data, date_range)
      }
    },
    async excuteQuery(set_data, date_range) {
      let _fromDate = "",
        _toDate = ""
      let _params = {
        NameAlias: { like: "%" + this.NameAlias + "%" },
        SEI_Name: { like: "%" + this.SEI_Name + "%" },
      }
      _params.is_deleted_ax = { "=": 0 }
      if (this.ItemId != "") {
        _params.ItemId = { like: "%" + this.ItemId + "%" }
      }
      if (this.TEC_CustAccount != "") {
        _params.TEC_CustAccount = { like: "%" + this.TEC_CustAccount + "%" }
      }
      if (
        !_.isNull(date_range) &&
        this.ItemId == "" &&
        this.NameAlias == "" &&
        this.SEI_Name == "" &&
        this.TEC_CustAccount == ""
      ) {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        // _params["fromDate"] = _fromDate
        // _params["toDate"] = _toDate
        _params["modifiedDateTime"] = { ">=": _fromDate, "<=": _toDate }
      }
      set_data([])
      let _result = await InventTableController.methods.getDataNoSql(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["modifiedDateTime"], ["desc"]))
      }
      this.isBusy_table1 = false
    },
    //#endregion

    //#region 状态切换
    state_change(data, cb) {
    },
    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) {
    },
    //#endregion

    current_changed(old, current) {
      if (_.isNull(current)) {
        this.$refs.InventTable2.SetData([])
        return
      }
      this.getItemData(current)
    },
    async getItemData(current) {
      this.isBusy_table2 = true
      this.$refs.InventTable2.SetData([])
      // let _result = await InventTableController.methods.getItemData({ ItemId: { "=": current.ItemId } });
      let _result = await InventTableController.methods.getItemData({
        ItemId: current.ItemId,
        is_deleted_ax: "0",
      })
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.$refs.InventTable2.SetData(_.orderBy(_result[0], ["id"], ["asc"]))
      }
      this.isBusy_table2 = false
    },
    async InvokeData() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.in_async"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      let _is_wait = true
      setTimeout(() => {
        if (_is_wait) {
          this.msgToasts(this.$t("notify.async_timeout"), "info")
          loading.close()
          _is_wait = false
        }
        return
      }, 1000 * 60 * 5)

      let companys = this.$store.state.biz_data.baseData.CompanyInfo
      for (var i in companys) {
        let _params = {
          company: companys[i].DataArea,
          tableName: "secp_InventTable",
          accountNum: "", //不传则查询所有
        }
        await InventTableController.methods.pickAndInvoke(_params)
      }
      let _p = {
        company: "070",
        tableName: "secp_SEI_InventTable",
        accountNum: "", //不传则查询所有
      }
      await InventTableController.methods.pickAndInvoke(_p)

      loading.close()
      if (_is_wait) {
        this.msgToasts(this.$t("notify.async_success"), "success")
        _is_wait = false
      }
      this.isBusy_table1 = true
      if (isNaN(this._set_data) && isNaN(this._date_range)) {
        this.$refs.InventTable1.SetData([])
        let _params = {
          modifiedDateTime: {
            ">=": this.$date.format(
              new Date().setMonth(new Date().getMonth() - 1),
              "yyyy-MM-dd"
            ),
            "<=": this.$date.format(
              this.$date.addDays(new Date(), 1),
              "yyyy-MM-dd"
            ),
          },
        }
        let _result = await InventTableController.methods.getDataNoSql(_params)
        if (!_.isNull(_result) && _result && _result.length > 0) {
          this.$refs.InventTable1.SetData(
            _.orderBy(_result[0], ["modifiedDateTime"], ["desc"])
          )
        }
      } else {
        await this.on_query(this._set_data, this._date_range)
      }

      this.isBusy_table1 = false
    },
  },
}
</script>
<style>
.hb_table_inventsei_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 180rem;
}

.hb_table_inventsei_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 300rem;
}
</style>
